import Navbar from './Tabs/NavBar/Navbar';
import PageTransition from './PageTransition';
import Footer from './Tabs/Footer/Footer';
import CartNotification from './CartNotification';

function Layout() {
  return (
    <div className="site-wrap">
      <Navbar />
      <CartNotification />

      <main className="site-content">
        <PageTransition />
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
